import React from "react";
import { useLang } from "@/context/LangContext";
import SEO from "@/components/SEO";
import { Bed, UtensilsCrossed, Bike, Compass, Luggage } from "lucide-react";

const Servizi = () => {
  const { t } = useLang();
  const items = [
    { icon: Bed, title: t("servizi_sleep"), desc: t("servizi_sleep_desc") },
    { icon: UtensilsCrossed, title: t("servizi_eat"), desc: t("servizi_eat_desc") },
    { icon: Bike, title: t("servizi_bike"), desc: t("servizi_bike_desc") },
    { icon: Compass, title: t("servizi_guide"), desc: t("servizi_guide_desc") },
    { icon: Luggage, title: t("servizi_bags"), desc: t("servizi_bags_desc") },
  ];

  return (
    <div data-testid="servizi-page">
      <SEO
        titleIt="Servizi — Dormire, mangiare, noleggio bici e trasporto bagagli"
        titleEn="Services — Accommodation, food, bike rental and luggage transfer"
        descriptionIt="Servizi lungo il Cammino Ibleo UNESCO: strutture ricettive selezionate, ristoranti locali, noleggio bici, guide del territorio e trasporto bagagli tappa per tappa."
        descriptionEn="Services along the Cammino Ibleo UNESCO: selected accommodation, local restaurants, bike rental, local guides and stage-to-stage luggage transfer."
      />
      <section className="pt-40 pb-16 bg-pietra-light border-b border-carrubo/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="eyebrow mb-6">Servizi</div>
          <h1 className="font-serif text-5xl md:text-7xl text-grafite mb-4">{t("servizi_title")}</h1>
          <p className="text-lg text-grafite-soft max-w-3xl">{t("servizi_subtitle")}</p>
        </div>
      </section>

      <section className="py-20 bg-pietra">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <div key={i} data-testid={`servizio-${i}`} className="p-8 bg-pietra-light rounded-sm border border-carrubo/10">
              <it.icon size={32} className="text-carrubo mb-6" strokeWidth={1.3} />
              <h3 className="font-serif text-2xl text-grafite mb-3">{it.title}</h3>
              <p className="text-grafite-soft leading-relaxed">{it.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Servizi;
